<ul>
  <!-- Run Cell -->
  <li>
    <mode-notebook-run-cell-button
      [canRun]="canRun && !(isExporting$ | async)"
      [cellToken]="cellToken"
      [nextCellToken]="nextCellToken"
      (runCell)="run($event)"
    >
    </mode-notebook-run-cell-button>
  </li>
  <!-- New cell -->
  <li>
    <mode-notebook-add-cell-button
      [cellToken]="cellToken"
      [nextCellToken]="nextCellToken"
      (insertCellAbove)="cellAbove()"
      (insertCellBelow)="cellBelow()"
    >
    </mode-notebook-add-cell-button>
  </li>

  <!-- Move cell up -->
  <li [class.disabled]="!prevCellToken">
    <capra-icon
      capraTooltip
      tooltipContent="Move cell up (Shift + Alt + &#8593;)"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      icon="icon-control-move-cell-up"
      (click)="prevCellToken && moveCellDirection('up')"
    ></capra-icon>
  </li>
  <!-- Move cell down -->
  <li [class.disabled]="!nextCellToken">
    <capra-icon
      capraTooltip
      tooltipContent="Move cell down (Shift + Alt + &#8595;)"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      icon="icon-control-move-cell-down"
      (click)="nextCellToken && moveCellDirection('down')"
    ></capra-icon>
  </li>

  <li>
    <span class="separator"></span>
  </li>

  <!-- Fold/Unfold cell -->
  <li [class.--active]="isFolded" [class.disabled]="!cellToken">
    <capra-icon
      capraTooltip
      [tooltipContent]="!isFolded ? 'Fold cell' : 'Unfold cell'"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      icon="icon-control-fold"
      (click)="toggleFoldCell()"
    ></capra-icon>
  </li>

  <!-- Freeze cell -->
  <li [class.--active]="isFrozen" [class.disabled]="!canFreeze || !cellToken">
    <capra-icon
      capraTooltip
      [tooltipContent]="isFrozen ? 'Unfreeze cell' : 'Freeze cell'"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      icon="icon-control-freeze"
      (click)="canFreeze && toggleFreezeCell()"
    ></capra-icon>
  </li>

  <li class="--no-border">
    <div
      capraTooltip
      [tooltipIsDisabled]="!(isCellExported$ | async)"
      tooltipContent="Cell type can’t be changed when a dataset is generated from its output"
      tooltipPlacement="bottom"
    >
      <select
        class="mode-select"
        data-test="select-cell-code-type"
        [disabled]="(isExporting$ | async) || (isCellExported$ | async)"
        (change)="updateContentType()"
        [(ngModel)]="cellContentType"
      >
        <option value="python">Code</option>
        <option value="markdown">Markdown</option>
      </select>
    </div>
  </li>

  <li>
    <span class="separator"></span>
  </li>

  <li class="--no-border">
    <ng-container *ngIf="!enableNotebookExportDatasets; else useOutputButton">
      <!-- Add to Report -->
      <mode-notebook-included-report-cell-button
        *ngIf="!thoughtspotIntegrated"
        [cellToken]="cellToken"
        [disabled]="!hasResult"
        [state]="includedInReport"
        (toggle)="toggleIncluedInReport($event)"
      >
      </mode-notebook-included-report-cell-button>
    </ng-container>
    <ng-template #useOutputButton>
      <!-- Use Output Button -->
      <mode-notebook-use-output-menu
        [cellToken]="cellToken"
        [disabled]="!hasResult"
        [isOutputUsed]="includedInReport"
        (toggle)="toggleIncluedInReport($event)"
      >
      </mode-notebook-use-output-menu>
    </ng-template>
  </li>

  <!-- Delete cell -->
  <li [class.disabled]="!canDelete">
    <capra-icon
      capraTooltip
      tooltipContent="Delete cell"
      tooltipPlacement="bottom"
      tooltipSize="mini"
      icon="icon-control-delete-cell"
      (click)="canDelete && delete()"
    ></capra-icon>
  </li>
</ul>
